import React from 'react'
// import PropTypes from 'prop-types'
import { Field } from 'formik'
import FormikFieldAntdInputWrapper from './FormikFieldAntdInputWrapper'
import { Checkbox, Icon } from 'antd'

class CreatorTodoEditor extends React.Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange (e) {
    this.props.updateTodoCompletion(e.target.checked)
  }

  render () {
    const displayIndex = this.props.index + 1
    const { completed } = this.props.todoItem
    const classNames = completed
      ? 'todo-completed todo-container'
      : 'todo-container'

    return (
      <div className={classNames}>
        <div className='todo-index'>{displayIndex}</div>
        <Checkbox
          className='todo-toggle'
          checked={completed}
          onChange={this.handleChange} />
        <div className='todo-title-wrapper'>
          <Field
            type='TEXTAREA'
            className='todo-title-editor'
            name={`todo-${this.props.todoItem.id}`}
            emptyAllowed={false}
            fallback={`Item ${displayIndex}`}
            updateField={this.props.updateTodoTitle}
            component={FormikFieldAntdInputWrapper} />
        </div>
        <div className='todo-delete-wrapper'>
          <Icon
            className='todo-delete'
            type='delete'
            theme='outlined'
            onClick={this.props.deleteTodo} />
        </div>
      </div>
    )
  }
}

/* //
CreatorTodoEditor.propTypes = {
  index: PropTypes.number.isRequired,
  updateTodoCompletion: PropTypes.func.isRequired,
  todoItem: PropTypes.shape({
    completed: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired
}
// */

export default CreatorTodoEditor



// WEBPACK FOOTER //
// ./src/components/CreatorTodoEditor.js